import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {locale as polish} from './i18n/pl';
import {FuseTranslationLoaderService} from "../../../../@fuse/services/translation-loader.service";
import {TranslateService} from "@ngx-translate/core";
import {MessageTemplate} from "../../models/messageTemplate";
import {NotificationAccountService} from "../../services/notificationAccount.service";
import {NotificationAccount} from "../../models/notificationAccount";
import {first} from "rxjs/operators";
import {NotificationAccountList} from "../../models/notificationAccountList";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";


@Component({
    selector: 'test-message-dialog',
    templateUrl: './testMessageDialog.component.html',
    styleUrls: ['./testMessageDialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class TestMessageDialogComponent {
    action: string;
    dialogTitle: string;
    showSeconds = false;
    dialogRef: any;
    testForm: FormGroup;
    editMode: boolean = false;
    messageTemplate: MessageTemplate;
    notificationAccounts: NotificationAccount[];

    constructor(
        public matDialogRef: MatDialogRef<TestMessageDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private translationLoader: FuseTranslationLoaderService,
        translate: TranslateService,
        public _matDialog: MatDialog,
        private _formBuilder: FormBuilder,
        private notificationAccountService: NotificationAccountService,
    ) {
        this.translationLoader.loadTranslations(polish);

        this.notificationAccountService.getAll(0, 100).pipe(first())
            .subscribe((res: NotificationAccountList) => {
                    this.notificationAccounts = res.items;
                    // this.page = pagedData.page;
                },
                error => {
                })

        this.messageTemplate = _data.event;

        this.testForm = this._formBuilder.group({
            notificationAccount: ['', Validators.required],
            receiver: ['', Validators.required],
        });
    }
}
